<template>
  <div class="container h-100">
    <div class="row justify-content-center align-items-center h-100">
      <div class="col text-center">
        <h1 class="mt-4">404</h1>
        <p class="mt-4">ページが見つかりませんでした。</p>
      </div>
    </div>
  </div>
</template>

<script setup>
</script>

<style scoped>
img {
  height: 30px;
}
</style>
